import routerOptions0 from "/builds/aschehoug/aschehoug-utdanning/vgs-app/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}